import { createContext, ReactNode } from 'react';

export interface SidebarManagerContextValue {
  showSidebar: (sidebar: ReactNode) => void;
}

export const SidebarManagerContext = createContext<SidebarManagerContextValue>({
  showSidebar: () => {
    throw new Error('showSidebar was used outside of SidebarManagerContext!');
  },
});
